class CouponCode extends HTMLElement {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
        this.svgs = this.querySelectorAll('svg');
        this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
    }

    handleClick() {
        const code = this.getAttribute('data-code');
        if (code) {
            // 将代码复制到剪贴板
            navigator.clipboard.writeText(code).then(() => {
                console.log('Coupon code copied to clipboard:', code);

                // 切换 SVG 的显示状态
                if (this.svgs.length >= 2) {
                    this.svgs[0].style.display = 'none';
                    this.svgs[1].style.display = 'block';

                    // 2秒后恢复
                    setTimeout(() => {
                        this.svgs[0].style.display = 'block';
                        this.svgs[1].style.display = 'none';
                    }, 2000);
                }
            }).catch(err => {
                console.error('Could not copy text: ', err);
            });
        }
    }
}

// 注册自定义元素
customElements.define('coupon-code', CouponCode);